import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"
import { PaymentsLinkStepUi } from "@src/widgets/onboarding/ui/tours/SendingInvoices/PaymentsLinkStepUi"

export class PaymentsLinkStep extends TourStepBase {
  component = PaymentsLinkStepUi
  name = `${ONBOARDING_TOURS.SENDING_INVOICES}_PaymentsLink`

  constructor() {
    super({
      highlightElements: [
        "#GENERATED_ID_PAYMENTLINKFORM_FORM_VOID_1",
        "#GENERATED_ID_SUBMITBUTTON_BUTTON_VOID_1",
      ],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.paymentLinksCreate,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Enhance payment flexibility for your customers",
      title: "Sending Payment Links",
    }
  }
}
